import { FunctionalComponent, h } from '@stencil/core';
import * as showdown from 'showdown'

interface AppRTE {
    markdown: string;
    className?: string;
}

export const AppRTE: FunctionalComponent<AppRTE> = ({ markdown, className }) => {
    
    const classMap = {
        h1: 'uk-heading-large wsio-text-700 uk-text',
        h2: 'uk-heading-medium wsio-text-700',
        h3: 'uk-heading-small uk-text-primary uk-text-bold',
        h4: 'uk-margin-remove-top uk-text-lead',
        h5: 'uk-margin-remove-top uk-article-meta',
        ul: 'uk-list uk-list-disc',
        ol: 'uk-list uk-list-decimal',
        button: 'uk-button uk-button-primary',
        blockquote: 'uk-padding',
        strong: 'uk-text-bold',
        em:'uk-text-primary',
        img: 'uk-padding',
        // p:'uk-display-inline-block'
    }

    const bindings = Object.keys(classMap)
        .map(key => ({
            type: 'output',
            regex: new RegExp(`<${key}(.*)>`, 'g'),
            replace: `<${key} class="${classMap[key]}" $1>`
        }));

    const converter = new showdown.Converter({
        extensions: [...bindings],
        strikethrough: true,
        simpleLineBreaks: true
    })

    return <div class={`uk-rte ${className}`} innerHTML={converter.makeHtml(markdown)} />
};